import React, { useState, useEffect } from "react";
import classNames from "../../classNames";
import DateRangePicker from "../common/DateRangePicker";
import { DatePicker, Space } from "antd";
import dayjs from "dayjs";

const noop = () => {};
const defaultProps = {
  type: "text",
  strict: false,
  onChange: noop,
  onclickAction: noop,
};

function StringArray({
  className,
  _type,
  type,
  strict,
  onChange,
  uppercase,
  disabled,
  _label = [],
  defaultValue = [],
  _field = [],
  onclickAction,
  ...props
}) {
  // Initialize state with defaultValue or empty rows based on `_field`
  const initialValues =
    defaultValue.length > 0 ? defaultValue : [Array(_field.length).fill("")];

  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    // Sync with external defaultValue when it changes
    if (defaultValue.length > 0) {
      setValues(defaultValue);
    }
  }, [defaultValue]);

  function onInput(rowIndex, inputIndex, e) {
    let newValue = e.target.value;
    if (uppercase) {
      newValue = newValue.toUpperCase();
    }

    // Update the value at the specific row and index
    const updatedValues = [...values];
    updatedValues[rowIndex][inputIndex] = newValue;

    // Update state and call onChange
    setValues(updatedValues);
    onChange(updatedValues);
  }
  function dateRange(rowIndex, inputIndex, e) {
    let newValue = e;
    if (uppercase) {
      newValue = newValue.toUpperCase();
    }

    // Update the value at the specific row and index
    const updatedValues = [...values];
    updatedValues[rowIndex][inputIndex] = newValue;

    // Update state and call onChange
    setValues(updatedValues);
    onChange(updatedValues);
  }

  function onClickAdd() {
    onclickAction("Add");
    // Add a new row with empty inputs based on `_field` size
    setValues([...values, Array(_field.length).fill("")]);
  }

  function onClickRemove(rowIndex) {
    onclickAction("Remove");
    const updatedValues = values.filter((_, index) => index !== rowIndex);
    setValues(updatedValues);
    onChange(updatedValues);
  }
  const { RangePicker } = DatePicker;
  const _noField = _field[0];

  return (
    <div className="col-12 ">
      {_noField !== "no-field" && <hr />}
      {values.map((row, rowIndex) => (
        <div key={rowIndex} className="row g-3">
          {_noField === "no-field" ? (
            <>
              {row.map((value, inputIndex) => {
                const isRangePicker = _label[inputIndex] === "Date Range";

                return (
                  <React.Fragment key={inputIndex}>
                    {isRangePicker ? (
                      <div className="col d-flex align-items-end justify-content-center  mt-3">
                        <Space
                          direction="vertical"
                          size={20}
                          className="d-flex flex-grow-1"
                          style={{ height: "2.5rem" }}
                        >
                          <RangePicker
                            required
                            value={
                              value && value[0] !== ""
                                ? [
                                    dayjs(value[0] || null),
                                    dayjs(value[1] || null),
                                  ]
                                : null
                            }
                            onChange={(date, value) =>
                              dateRange(rowIndex, inputIndex, value)
                            }
                            className="custom-range-picker border p-2 fw-semibold"
                            disabled={disabled}
                            allowClear={props.allowClear !== false}
                            {...props}
                          />
                        </Space>

                        <button
                          disabled={disabled}
                          onClick={() => onClickRemove(rowIndex)}
                          type="button"
                          className="btn btn-link text-danger btn-sm fs-xs "
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                      </div>
                    ) : (
                      <div
                        className={
                          _field.length === 1 ? "col-md-11" : "col-md-5"
                        }
                      >
                        {_label[inputIndex] && (
                          <label className="form-label fs-sm mt-2">
                            {_label[inputIndex]}
                          </label>
                        )}

                        {_label[inputIndex] === "Reason for Medication" ||
                        _label[inputIndex] === "Remarks" ? (
                          <textarea
                            className={classNames("form-control", className)}
                            value={value}
                            onChange={(e) => onInput(rowIndex, inputIndex, e)}
                            rows={3}
                            disabled={disabled}
                            {...props}
                          />
                        ) : _label[inputIndex] === "Date Of Vaccination" ||
                          _label[inputIndex] === "Date" ? (
                          <input
                            className={classNames("form-control", className)}
                            style={{ height: "2.5rem" }}
                            type="Date"
                            value={value}
                            onChange={(e) => onInput(rowIndex, inputIndex, e)}
                            disabled={disabled}
                            {...props}
                          />
                        ) : (
                          <input
                            className={classNames("form-control", className)}
                            style={{ height: "2.5rem" }}
                            value={value}
                            onChange={(e) => onInput(rowIndex, inputIndex, e)}
                            disabled={disabled}
                            {...props}
                          />
                        )}
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            </>
          ) : (
            <>
              {row.map((value, inputIndex) => {
                return (
                  <div
                    className={_field.length === 1 ? "col-md-11" : "col-md-5"}
                    key={inputIndex}
                  >
                    {_noField !== "no-field" && (
                      <label className="form-label fs-sm mt-2">
                        {_label[inputIndex] || ""}
                      </label>
                    )}
                    {_label[inputIndex] === "Reason for Medication" ||
                    _label[inputIndex] === "Remarks" ? (
                      <textarea
                        className={classNames("form-control", className)}
                        value={value}
                        onChange={(e) => onInput(rowIndex, inputIndex, e)}
                        rows={3}
                        disabled={disabled}
                        {...props}
                      />
                    ) : _label[inputIndex] === "Date Of Vaccination" ||
                      _label[inputIndex] === "Date" ? (
                      <input
                        className={classNames("form-control", className)}
                        style={{ height: "2.5rem" }}
                        type="Date"
                        value={value}
                        onChange={(e) => onInput(rowIndex, inputIndex, e)}
                        disabled={disabled}
                        {...props}
                      />
                    ) : _label[inputIndex] === "Date Range" ? (
                      <Space
                        direction="vertical"
                        size={20}
                        className="d-flex"
                        style={{ height: "2.5rem" }}
                      >
                        <RangePicker
                          required
                          value={
                            value && value[0] !== ""
                              ? [
                                  dayjs(value[0] || null),
                                  dayjs(value[1] || null),
                                ]
                              : null
                          }
                          onChange={(date, value) =>
                            dateRange(rowIndex, inputIndex, value)
                          }
                          className="custom-range-picker border p-2 fw-semibold"
                          disabled={disabled}
                          {...props}
                        />
                      </Space>
                    ) : (
                      <input
                        className={classNames("form-control", className)}
                        style={{ height: "2.5rem" }}
                        value={value}
                        onChange={(e) => onInput(rowIndex, inputIndex, e)}
                        disabled={disabled}
                        {...props}
                      />
                    )}
                  </div>
                );
              })}

              <div className="pb-1 col mt-auto">
                <button
                  disabled={disabled}
                  onClick={() => onClickRemove(rowIndex)}
                  type="button"
                  className="btn btn-link text-danger btn-sm fs-xs"
                >
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            </>
          )}
        </div>
      ))}

      <button
        disabled={disabled}
        onClick={onClickAdd}
        type="button"
        className="btn btn-light btn-sm fs-xs mt-3 mb-3 text-uppercase"
      >
        <i className="bi bi-plus me-2"></i> ADD MORE
      </button>
    </div>
  );
}

StringArray.defaultProps = defaultProps;
export default StringArray;
